<template>
    <div class="section-cards" :class="color">
        <layout-contained :class="padding">
            <div class="flex justify-between">
                <content-subheading
                    v-if="heading"
                    :heading="heading"
                    :headingColor="headingColor"
                    :headingComponent="headingComponent"
                    :textCentered="textCentered"
                ></content-subheading>
                <div v-if="buttonText" :class="!!textCentered ? 'text-center' : ''">
                    <button-videos
                        class="-mt-2"
                        :buttonColor="buttonColor || undefined"
                        :buttonRoute="buttonRoute"
                        :buttonText="buttonText"
                        :buttonClick="buttonClick"
                        :buttonClickParams="buttonClickParams"
                    ></button-videos>
                </div>
            </div>
            <content-text
                v-if="content"
                :html="content"
                :contentColor="contentColor"
                :textCentered="textCentered"
            ></content-text>
            <div v-if="$slots.search" :class="heading || content ? 'mt-3 sm:mt-5' : ''">
                <slot name="search"></slot>
            </div>
            <layout-cards
                v-if="cards && cards.length"
                :class="heading || content ? 'mt-5 sm:mt-8' : ''"
                :cards="cards"
                :contentful="contentful"
            ></layout-cards>
            <layout-infinite-scroll v-if="cards !== null" v-bind="{hasMore, loadMore}"></layout-infinite-scroll>
            <slot name="custom"></slot>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'SectionCards',
    props: {
        cards: {
            required: false,
            type: Array,
            default() {
                return [];
            },
        },
        hasMore: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        loadMore: {
            required: false,
            type: Function,
            default: null,
        },
        padding: {
            required: false,
            default: 'py-8 sm:py-10',
            type: String,
        },
        contentful: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        buttonColor: {
            required: false,
            type: String,
            default: null,
        },
        buttonRoute: {
            required: false,
            type: [String, Object],
            default: null,
        },
        buttonText: {
            required: false,
            type: String,
            default: null,
        },
        buttonClick: {
            required: false,
            type: Function,
            default: () => {},
        },
        buttonClickParams: {
            required: false,
            type: [String, Object, Array],
            default: null,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-zinc-900',
        },
        content: {
            required: false,
            type: String,
            default: null,
        },
        contentColor: {
            required: false,
            type: String,
            default: 'text-zinc-400',
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-zinc-100',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h1',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
};
</script>
